import React from 'react';
import { TableSummaryByTasksData } from '../../model';
import {
	Table,
	Tr,
	Th,
	Thead,
	Tbody,
	TableWithScroll,
	Complexity,
	Name,
	Description,
	Сorrect,
	СorrectByRF,
} from './SummaryByTasksStyled';

const createRow = (data: TableSummaryByTasksData) => {
	return (
		<Tr>
			<Complexity>{data.difficulty}</Complexity>
			<Name Bold>{data.name}</Name>
			<Description>{data.description}</Description>
			<Сorrect>{data.correctAnswersPercent}%</Сorrect>
			<СorrectByRF>{data.correctAnswersPercentRussia}%</СorrectByRF>
		</Tr>
	);
};

const TableSummaryByTask = (props: { rows?: TableSummaryByTasksData[] }) => {
	return (
		<>
			<Table>
				<Thead>
					<Tr>
						<Complexity as={Th} style={{ width: 192 }}>
							Сложность
						</Complexity>
						<Name as={Th} style={{ width: 211 }}>
							Название
						</Name>
						<Description as={Th} style={{ width: 311 }}>
							Описание
						</Description>
						<Сorrect as={Th}>Верных решений</Сorrect>
						<СorrectByRF as={Th}>Верных по РФ</СorrectByRF>
					</Tr>
				</Thead>
			</Table>
			<TableWithScroll style={{ marginBottom: 16 }}>
				<Table>
					<Tbody>{props.rows?.map((el) => createRow(el))}</Tbody>
				</Table>
			</TableWithScroll>
		</>
	);
};
export default TableSummaryByTask;
